/**
 * History Item Text Component
 * Displays the truncated text content of a history entry
 * Follows SRP - single responsibility for text rendering
 */

import React from 'react';
import {
  typographyColors,
  typography,
  fontPrimary,
  spacing,
} from '@/design-system/utils';

interface HistoryItemTextProps {
  title: string;
  description?: string;
  maxLines?: number;
  maxWidth?: string;
}

export const HistoryItemText: React.FC<HistoryItemTextProps> = ({
  title,
  description,
  maxLines = 2,
  maxWidth,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[1],
        flexShrink: 1,
        ...(maxWidth ? { maxWidth } : {}),
      }}
      className='md:max-w-[460px] max-w-[180px]'
    >
      <p
        style={{
          color: typographyColors.primary,
          textOverflow: 'ellipsis',
          fontFamily: fontPrimary,
          fontSize: typography.size.base,
          fontStyle: 'normal',
          fontWeight: typography.weight.medium,
          lineHeight: 'normal',
          margin: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </p>
      {description && (
        <p
          style={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: maxLines,
            overflow: 'hidden',
            color: typographyColors.secondary,
            textOverflow: 'ellipsis',
            fontFamily: fontPrimary,
            fontSize: typography.size.sm,
            fontStyle: 'normal',
            fontWeight: typography.weight.regular,
            lineHeight: 'normal',
            margin: 0,
          }}
        >
          {description}
        </p>
      )}
    </div>
  );
};
